import { css } from '@emotion/react';
import { theme } from '../theme';
import { tokens } from '../tokens';
// Mappings between badge's sizes and variants, and design tokens
var sizeMap = {
    large: {
        fontSize: tokens.fontSizes.medium,
        sizing: '20px',
    },
    medium: {
        fontSize: tokens.fontSizes.small,
        sizing: '18px',
    },
    small: {
        fontSize: tokens.fontSizes.xsmall,
        sizing: '14px',
    },
};
var badgeStaticStyle = css({
    alignItems: 'center',
    borderRadius: tokens.borderRadius.medium,
    display: 'inline-flex',
    fontFamily: tokens.fontFamilies.sansSerif,
    fontWeight: tokens.fontWeights.bold,
    justifyContent: 'center',
    letterSpacing: '0.5px',
    lineHeight: tokens.lineHeights.tight,
    paddingLeft: tokens.spacing.xsmall,
    paddingRight: tokens.spacing.xsmall,
    textTransform: 'uppercase',
});
export function badgeStyle(_a) {
    var size = _a.size, variant = _a.variant;
    var isTransparentGrey = variant === 'greyLight' || variant === 'transparentGrey';
    // Set the styles as the default base colors or the specified accent variant
    var variantStyle = variant === 'base'
        ? {
            main: theme.background.contrastInverse,
            textOnColor: theme.text.inverse,
        }
        : theme[isTransparentGrey ? 'transparentGrey' : variant];
    return [
        badgeStaticStyle,
        css({
            backgroundColor: isTransparentGrey
                ? variantStyle.subtler
                : variantStyle.main,
            color: variantStyle.textOnColor,
            fontSize: sizeMap[size].fontSize,
            height: sizeMap[size].sizing,
        }),
    ];
}
export var innerContentStaticStyle = css({
    maxWidth: '164px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});
